import { Voucher, createDeleteVoucherMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteVoucherModel = ConfirmModalModel<Voucher, number, Voucher>;

export const createDeleteVoucherModel = (): DeleteVoucherModel => {
	const deleteVoucherMutation = createDeleteVoucherMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<Voucher>(),
		mapModalData: ({ id }) => id,
		mutation: deleteVoucherMutation,
		successMessageKey: 'delete-voucher.success',
	});

	return model;
};
